import React from 'react';
import { Icon } from '../Icon';
import { AutoplayCarousel } from '../AutoplayCarousel';
import styles from './FeedbackList.css';

const LIST = [
    {
        id: 1,
        author: 'Brenda',
        age: 43,
        location: 'Kansas',
        title: 'I didn’t know what to do !!',
        description: 'U were there when I didn’t know what to do !!',
        initials: 'BR',
        avatarColor: '#4D609A'
    },
    {
        id: 2,
        author: 'Robert Wilson',
        age: 62,
        location: 'Port Vila - New Zealand',
        title: 'I appreciate the support',
        description: 'For me personally I appreciate the support in securing my online business from the hackers, as I have been hacked and the hackers stealing my online business information. Thank you so much for your service rendered to me.',
        initials: 'RW',
        avatarColor: '#3B945F'
    },
    {
        id: 3,
        author: 'Aaron Clark',
        age: 45,
        location: 'Georgia',
        title: 'Thank y’all very much.',
        description: 'I am completely satisfied with the service that I received from your company. The customer service personnel were very friendly and knew what to do. There could not have been a better service than what I received. Thank y’all very much.',
        initials: 'AC',
        avatarColor: '#9C5052'
    },
    {
        id: 4,
        author: 'Karen Foutch',
        age: 68,
        location: 'Missouri',
        title: 'Your emails were helpful!',
        description: 'Your emails were helpful! I appreciate you keeping in touch to see if I need more help and I do was going to contact you tomorrow. I believe one of your emails had your phone number. Very nice of you to provide it to me. Thank you.',
        initials: 'KF',
        avatarColor: '#735396'
    },
    {
        id: 5,
        author: 'Rata Wiki',
        age: 58,
        location: 'New Zealand',
        title: 'Request was handle swiftly and an positive outcome',
        description: 'The response from my request was handle swiftly and an positive outcome. Very happy with their services.',
        initials: 'RW',
        avatarColor: '#418A94'
    }
];

function FeedbackList() {
    return (
        <AutoplayCarousel className={styles.slider}>
            {LIST.map(item => (
                <article className={styles.slide} key={item.id}>
                    <header className={styles.header}>
                        <div
                            className={styles.avatar}
                            style={{ backgroundColor: item.avatarColor }}
                            aria-hidden='true'
                        >
                            {item.initials}
                        </div>
                        <div>
                            <div className={styles.nameRow}>
                                <span className={styles.author}>
                                    {item.author}, {item.age}
                                </span>
                                <Icon name='verified' className={styles.verified} aria-label='Verified' />
                            </div>
                            <span className={styles.location}>{item.location}</span>
                        </div>
                    </header>
                    <p className={styles.title}>&ldquo;{item.title}&rdquo;</p>
                    <p className={styles.description}>{item.description}</p>
                </article>
            ))}
        </AutoplayCarousel>
    );
}

export {
    FeedbackList
};
